/// <amd-module name="SuiteCommerce.PagePrinter.ItemDetailsLayout.Configuration"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.PagePrinter.ItemDetailsLayout.Configuration", ["require", "exports", "SuiteCommerce.PagePrinter.Common.Configuration", "Backbone"], function (require, exports, Configuration_1, Backbone_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var ShowUrlOptions;
    (function (ShowUrlOptions) {
        ShowUrlOptions["ShowAsText"] = "Text";
        ShowUrlOptions["ShowAsQrCode"] = "QR Code";
        ShowUrlOptions["CombineQrCodeAndText"] = "QR Code and Text";
        ShowUrlOptions["Hide"] = "Hide Item URL";
    })(ShowUrlOptions || (ShowUrlOptions = {}));
    var ItemDetailsConfiguration = /** @class */ (function (_super) {
        __extends(ItemDetailsConfiguration, _super);
        function ItemDetailsConfiguration() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        Object.defineProperty(ItemDetailsConfiguration, "companyLogoURL", {
            get: function () {
                return this.get('pagePrinterItemDetails.logoTemplate');
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(ItemDetailsConfiguration, "companyInformation", {
            get: function () {
                return this.get('pagePrinterItemDetails.companyContactInfo');
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(ItemDetailsConfiguration, "showPrice", {
            get: function () {
                return this.get('pagePrinterItemDetails.showPrice');
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(ItemDetailsConfiguration, "priceLabel", {
            get: function () {
                return this.get('pagePrinterItemDetails.priceLabel');
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(ItemDetailsConfiguration, "showSku", {
            get: function () {
                return this.get('pagePrinterItemDetails.showSku');
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(ItemDetailsConfiguration, "skuLabel", {
            get: function () {
                return this.get('pagePrinterItemDetails.skuLabel');
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(ItemDetailsConfiguration, "productReviews", {
            get: function () {
                return this.get('productReviews');
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(ItemDetailsConfiguration, "productReviewsMaxRate", {
            get: function () {
                return this.get('productReviews.maxRate', 5);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(ItemDetailsConfiguration, "showRating", {
            get: function () {
                return this.get('pagePrinterItemDetails.showRating');
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(ItemDetailsConfiguration, "ratingLabel", {
            get: function () {
                return this.get('pagePrinterItemDetails.ratingLabel');
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(ItemDetailsConfiguration, "isEnabledShowUrl", {
            get: function () {
                return this.get('pagePrinterItemDetails.itemUrl') !== ShowUrlOptions.Hide;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(ItemDetailsConfiguration, "isUrlDisplayedAsText", {
            get: function () {
                return this.get('pagePrinterItemDetails.itemUrl') === ShowUrlOptions.ShowAsText;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(ItemDetailsConfiguration, "isUrlDisplayedAsQr", {
            get: function () {
                return this.get('pagePrinterItemDetails.itemUrl') === ShowUrlOptions.ShowAsQrCode;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(ItemDetailsConfiguration, "isUrlDisplayedAsTextAndQr", {
            get: function () {
                return this.get('pagePrinterItemDetails.itemUrl') === ShowUrlOptions.CombineQrCodeAndText;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(ItemDetailsConfiguration, "notesFromTheSupplier", {
            get: function () {
                return this.get('pagePrinterItemDetails.notesFromTheSupplier');
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(ItemDetailsConfiguration, "matrixChildSectionLabel", {
            get: function () {
                return this.get('pagePrinterItemDetails.matrixChildSectionLabel');
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(ItemDetailsConfiguration, "itemFields", {
            get: function () {
                return this.get('pagePrinterItemDetails.itemFields') || [];
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(ItemDetailsConfiguration, "requireLoginForPricingMessage", {
            get: function () {
                return this.get('pagePrinterItemDetails.requireLoginForPricesMessage');
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(ItemDetailsConfiguration, "getUrlLogin", {
            get: function () {
                var session = this.get('siteSettings.touchpoints');
                var url = session.login +
                    '&origin=' +
                    (this.get('currentTouchpoint') || 'home') +
                    '&origin_hash=';
                return (url +
                    encodeURIComponent(Backbone_1.history.getFragment()));
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(ItemDetailsConfiguration, "isEnabledQuantityPricing", {
            get: function () {
                return this.get('siteSettings.quantitypricing');
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(ItemDetailsConfiguration, "itemNotFoundMessage", {
            get: function () {
                return this.get('pagePrinterItemDetails.itemNotFoundMessage');
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(ItemDetailsConfiguration, "continueShoppingButtonLabel", {
            get: function () {
                return this.get('pagePrinterItemDetails.continueShoppingButtonLabel');
            },
            enumerable: true,
            configurable: true
        });
        return ItemDetailsConfiguration;
    }(Configuration_1.Configuration));
    exports.ItemDetailsConfiguration = ItemDetailsConfiguration;
});
